let update_element = (actionData) => {
    let $el = $(actionData.selector);
    if (typeof actionData.value !== 'object') {
        $el.html(actionData.value);
        return;
    }
    if (actionData.value.hasOwnProperty('remove_classes')) {
        $el.removeClass(actionData.value.remove_classes);
    }
    if (actionData.value.hasOwnProperty('add_classes')) {
        $el.addClass(actionData.value.add_classes);
    }
    if (actionData.value.hasOwnProperty('classes')) {
        $el.removeClass().addClass(actionData.value.classes);
    }
    if (actionData.value.hasOwnProperty('content')) {
        $el.html(actionData.value.content);
    }
    if (actionData.value.hasOwnProperty('attributes')) {
        Object.entries(actionData.value.attributes).forEach(([attribute, value]) => {
            $el.attr(attribute, value);
        });
    }
};
export default update_element;